// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__YdBAO","logout":"footer_logout__elt7F"};